let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kNFvF"), load("fliVL"), load("kweWm")]).then(() => parcelRequire('5JaU6'));